import { VFC } from 'react'
import { useAppointmentTypes, useCustomer, useTimeZones, useUserSettings } from '../../../../../hooks'
import { AppointmentTypes, Customer, TimeZones } from '../../../../../types'
import { useIsConfigurationReadOnly } from '../../useIsConfigurationReadOnly'
import { Content } from './Content'

const Configuration: VFC = () => {
  const { appointmentTypes } = useAppointmentTypes()
  const { customer } = useCustomer()
  const { locale } = useUserSettings()
  const { timeZones } = useTimeZones()
  const isConfigurationReadOnly = useIsConfigurationReadOnly()

  return (
    <Content
      appointmentTypes={appointmentTypes as AppointmentTypes}
      customer={customer as Customer}
      isReadOnly={isConfigurationReadOnly}
      locale={locale}
      timeZones={timeZones as TimeZones}
    />
  )
}

export { Configuration }
